import React from 'react'
import { useTranslation } from 'react-i18next'

export default function DayReflectionNote({ note }) {
    const { t } = useTranslation()
    return (
        <div className="compare-note-container">
            <div className="note-compare-one">
                <div className="note-question">
                    <span>{t('whatAreJust3GoodThingsThatHappenedToday')}</span>
                </div>

                <div className="note-suggestions">
                    {note.things_happened_today.map((suggestion, index) => {
                        return (
                            <div className="v-center-flex">
                                <div className="note-suggestion-number">
                                    <span>{index + 1}.</span>
                                </div>
                                <div className="note-suggestion">{suggestion}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="note-compare-two">
                <div className="note-question">
                    <span>{t('What are three things that are a bit challenging at the moment?')}</span>
                </div>
                <div className="note-suggestions">
                    {note.challenging_things.map((suggestion, index) => {
                        return (
                            <div className="v-center-flex">
                                <div className="note-suggestion-number">
                                    <span>{index + 1}.</span>
                                </div>
                                <div className="note-suggestion">{suggestion}</div>
                            </div>
                        )
                    })}
                </div>
                <div className="note-compare-two">
                    <div className="note-question">
                        <span>{t('What’s just one thing you will do differently tomorrow?')}</span>
                    </div>
                    <div className="note-textarea">
                        <span>{note.tomorrow_plan}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
